import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { FormattedAdoverlayType } from '@app/modules/logger/screens/stream/components/audit/adoverlay/utils';
import { toTimestamp } from '@mi-front/core';
import { PlayButtonP } from './PlayButton';
import { Station } from '@app/core/types/stations';

export function PlayAdOverlayButton(p: { adOverlay: FormattedAdoverlayType; station: Station }) {
  const play = usePlaybackPlay();

  const handlePlay = () => {
    const startTs = toTimestamp(p.adOverlay.start_timestamp);
    const stopTs = toTimestamp(p.adOverlay.end_timestamp);

    play({
      startTs,
      stopTs,
    });
  };

  return <PlayButtonP play={handlePlay} />;
}
